function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const NewIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12V7h-1.2v4.5h-1.1V8h-1.3v3.5h-1.1V7h-1.3v5c0 .3.1.5.3.7.2.2.4.3.7.3h4c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7zm-7-3.7V7h-4v6h4v-1.3H9v-1.1h2.5V9.4H9V8.3h2.5zm-5 4.7V7H5.3v3.5L2.7 7H1.5v6h1.2V9.5L5.3 13h1.2zM18 2c.6 0 1 .2 1.4.6.4.4.6.8.6 1.4v12c0 .6-.2 1-.6 1.4-.4.4-.8.6-1.4.6H2c-.6 0-1-.2-1.4-.6S0 16.6 0 16V4c0-.6.2-1 .6-1.4C1 2.2 1.4 2 2 2h16z"
  }));
};
export default NewIcon;